export class Leitbild{

    public static leitbildVideo: HTMLVideoElement;
    public static leitbildVideoWrapper: HTMLElement;
    public static leitbildSlogan1: HTMLElement;
    public static leitbildSlogan2: HTMLElement;
    public static leitbildSlogan3: HTMLElement;
    public static leitbildLightOverlay: HTMLElement;
    public static leitbildOverlay: HTMLElement;
    public static leitbildCloseButton: HTMLElement;
    public static isVideoShown: boolean = false;
    public static isSloganShown1: boolean = false;
    public static isSloganShown2: boolean = false;
    public static isSloganShown3: boolean = false;
    public static isLightOverlayShown: boolean = false;
    public static isOverlayRemoved: boolean = false;
    public static videoShownAt: number;
    public static sloganShownAt1: number;
    public static sloganShownAt2: number;
    public static sloganShownAt3: number;
    public static lightOverlayShownAt: number;

    public static init(){
        document.addEventListener('DOMContentLoaded', this.onDocumentLoaded, false)
    }

    private static onDocumentLoaded() {
        let video = document.getElementById('lights-and-fog');
        if(video) {
            Leitbild.leitbildVideo = video as HTMLVideoElement;
            Leitbild.leitbildCloseButton = document.getElementById('close-overlay');
            Leitbild.leitbildSlogan1 = document.getElementById('for-the-moment-1');
            Leitbild.leitbildSlogan2 = document.getElementById('for-the-moment-2');
            Leitbild.leitbildSlogan3 = document.getElementById('for-the-moment-3');
            Leitbild.leitbildLightOverlay = document.getElementById('light-overlay');
            Leitbild.leitbildOverlay = document.getElementById('leitbild-overlay');
            Leitbild.leitbildVideoWrapper = document.getElementById('video-wrapper');
            Leitbild.leitbildCloseButton.addEventListener('click', Leitbild.closeOverlay);
            Leitbild.leitbildVideo.addEventListener("timeupdate", Leitbild.onVideoTimeUpdate);
        }
    }

    private static onVideoTimeUpdate(event: Event) {
        const target: HTMLVideoElement = event.target as HTMLVideoElement;
        if(!Leitbild.isVideoShown) {
            Leitbild.isVideoShown = true;
            Leitbild.videoShownAt = target.currentTime;
            Leitbild.leitbildOverlay.style.backgroundImage = 'none';
            Leitbild.leitbildVideoWrapper.classList.add('show-video');
        }

        if (
            Leitbild.isVideoShown
            && !Leitbild.isSloganShown1
            && target.currentTime > (Leitbild.videoShownAt + 1)
        ) {
            Leitbild.isSloganShown1 = true;
            Leitbild.sloganShownAt1 = target.currentTime;
            Leitbild.leitbildSlogan1.classList.add('show');
        }

        if (
            Leitbild.isSloganShown1
            && !Leitbild.isSloganShown2
            && target.currentTime > (Leitbild.sloganShownAt1 + .5)
        ) {
            Leitbild.isSloganShown2 = true;
            Leitbild.sloganShownAt2 = target.currentTime;
            Leitbild.leitbildSlogan2.classList.add('show');
        }

        if (
            Leitbild.isSloganShown2
            && !Leitbild.isSloganShown3
            && target.currentTime > (Leitbild.sloganShownAt2 + 1)
        ) {
            Leitbild.isSloganShown3 = true;
            Leitbild.sloganShownAt3 = target.currentTime;
            Leitbild.leitbildSlogan3.classList.add('show');
        }

        if (
            Leitbild.isSloganShown3
            && !Leitbild.isLightOverlayShown
            && target.currentTime > (Leitbild.sloganShownAt3 + 2)
        ) {
            Leitbild.isLightOverlayShown = true;
            Leitbild.lightOverlayShownAt = target.currentTime;
            Leitbild.leitbildLightOverlay.classList.add('show');
        }

        if(
            Leitbild.isVideoShown
            && Leitbild.isSloganShown3
            && !Leitbild.isOverlayRemoved
            && target.currentTime > (Leitbild.lightOverlayShownAt + 1)
        ) {
            Leitbild.isOverlayRemoved = true;
            Leitbild.leitbildOverlay.classList.add('remove-overlay');
            setTimeout(
                Leitbild.removeOverlay,
                2000
            );
        }
    }

    public static closeOverlay(event: Event) {
        event.preventDefault();
        Leitbild.removeOverlay();
    }
    private static removeOverlay() {
        Leitbild.leitbildOverlay.remove();
    }
}